import { type ClassStatus } from '../../context/types';

export type Order = 'asc' | 'desc';

export enum UserRoles {
    Student = 'student',
    Teacher = 'teacher',
    Assistant = 'assistant'
}

export type UserRole = `${UserRoles}`;

export enum UserRoleLevels {
    'student',
    'assistant',
    'teacher'
}

export interface RosterTableData {
    student_id: number;
    meeting_id: number;
    first_name: string;
    last_name: string;
    user_name: string;
    user_image: string;
    role: UserRole;
    student_uuid: string;
    seed: number;
    email: string;
    ext_user_id: string;
    student_group_names?: string[];
    has_zoom_login?: boolean;
}

export interface MyDetails {
    student_id: number;
    meeting_id: number;
    first_name: string;
    last_name: string;
    user_name: string;
    user_image: string;
    role: UserRole;
    student_uuid: string;
    seed: number;
    email: string;
}

export interface ClassInfo {
    class_name: string;
    sid: number;
    meeting_id: string;
    status: ClassStatus;
}

export type RosterTableColumns = keyof RosterTableData;
